import React from 'react'
import { Radio, RadioGroup } from '@entur/form'
import { GridContainer, GridItem } from '@entur/grid'

type FipChooseReportDateProps = {
  useCreatedAt: string
  update: (e: string) => void
}

const FIPChooseReportDate: React.FC<FipChooseReportDateProps> = (props) => {
  return (
    <GridContainer spacing="extraSmall2">
      <GridItem small={12} medium={4} large={4}>
        <RadioGroup
          name="choose-report-date"
          label="Uttaksdato"
          value={props.useCreatedAt}
          onChange={(e) => {
            props.update(e.target.value)
          }}
        >
          <Radio value="true" name="Registreringsdato">
            Registreringsdato
          </Radio>
          <Radio value="false" name="Utstedelsesdato">
            Utstedelsesdato
          </Radio>
        </RadioGroup>
      </GridItem>
    </GridContainer>
  )
}

export default FIPChooseReportDate
